'use client';

import { PopulationTrendsChartIsland } from '@/components/charts/PopulationTrendsChartIsland';
import { GA_CHART_ID } from '@/constants/analytics';

import {
  StateDonutChartChrome,
  useStateDonutChartFilters,
} from './StateDonutChartChrome';

import type { Messages } from '@/content/messages';
import type { Locale } from '@/lib/i18n';
import type { ReactNode } from 'react';

type PopulationTrendsChromeProps = {
  locale: Locale;
  charts: Messages['state']['charts'];
  chartHeader: ReactNode;
};

function PopulationTrendsChartSlot({
  locale,
  charts,
}: {
  locale: Locale;
  charts: Messages['state']['charts'];
}) {
  const {
    displayViewMode,
    flywayFilter,
    phase,
    onExitComplete,
    onEnterComplete,
  } = useStateDonutChartFilters();

  return (
    <PopulationTrendsChartIsland
      locale={locale}
      viewMode={displayViewMode}
      flywayFilter={flywayFilter}
      phase={phase}
      onExitComplete={onExitComplete}
      onEnterComplete={onEnterComplete}
      centerDescriptor={charts.populationTrends.centerDescriptor}
      ariaLabel={charts.populationTrends.ariaLabel}
      speciesGroupLabels={charts.speciesGroups}
      habitatLabels={charts.habitats}
      trendLabels={charts.populationTrends.trendLabels}
    />
  );
}

/**
 * Client island for Population Trends: wires shared chrome to the chart.
 */
export function PopulationTrendsChrome({
  locale,
  charts,
  chartHeader,
}: PopulationTrendsChromeProps) {
  return (
    <StateDonutChartChrome
      chartId={GA_CHART_ID.populationTrends}
      heading={charts.populationTrends.heading}
      charts={charts}
      datazoneUrl={charts.populationTrends.datazoneUrl}
      chartHeader={chartHeader}
    >
      <PopulationTrendsChartSlot locale={locale} charts={charts} />
    </StateDonutChartChrome>
  );
}
